import classNames from 'classnames';
import { ComponentProps } from 'react';
import { useViewport } from '@bpm-web-app/utils';
import PlusIcon from '../../../assets/icons/artist-platform/plus.svg';
import { AppLink } from '../app-link/app-link';

import styles from './see-more-btn.module.css';

export interface SeeMorePros {
    text?: string;
    onClick?: () => void;
    seeLess?: boolean;
    onSeeLess?: () => void;
    disabled?: boolean;
    expand?: boolean;
    variant?: 'container' | 'text' | 'tracklist';
}

export function SeeMore({ text = 'See More', onClick, seeLess = false, disabled, expand = true, variant = 'container', onSeeLess }: SeeMorePros) {
    const { isMobile } = useViewport();

    return (
        <>
            <button type="button" disabled={disabled} className={classNames({ [styles[`see-more-btn__${variant}`]]: variant, 'link-hover': variant === 'text' })} aria-label={text} onClick={onClick}>
                {expand ? <PlusIcon /> : null}
                {text}
            </button>
            {
                !isMobile && onSeeLess && (!!seeLess) ? (
                    <button type="button" disabled={!seeLess} className={classNames({ 'link-hover': seeLess }, styles['see-more-btn__see-less'])} aria-label="See Less" onClick={onSeeLess}>
                        See Less
                    </button>
                ) : null
            }
        </>
    );
}

type SeeMoreTracklistLinkProps = ComponentProps<typeof AppLink> & Pick<SeeMorePros, 'text' | 'disabled' | 'expand'>;

export function SeeMoreTracklistLink({ text, disabled, expand = false, ...linkProps }: SeeMoreTracklistLinkProps) {
    return (
        <AppLink {...linkProps}>
            <div className={styles['see-more-btn__tracklist-link']}>
                <SeeMore expand={expand} variant="tracklist" text={text} disabled={disabled} />
            </div>
        </AppLink>
    );
}

export default SeeMore;
